export function isTokenExpired(token: string): boolean {
  try {
    // JWT 구조: header.payload.signature
    // payload 부분(두 번째)을 추출
    const base64Payload = token.split('.')[1];

    // base64 → 문자열(JSON)로 디코딩
    const decodedPayload = atob(base64Payload);

    // JSON 문자열 → 객체로 변환
    const payload = JSON.parse(decodedPayload);

    // exp: 토큰 만료 시간 (초 단위, Unix timestamp)
    const exp = payload.exp;

    // 현재 시간 (초 단위로 맞춤)
    const now = Math.floor(Date.now() / 1000);

    // 현재 시간이 exp보다 크거나 같으면 만료
    return now >= exp;

  } catch (e) {
    // 토큰이 깨졌거나 형식이 이상하면
    // 안전하게 "만료된 것"으로 처리
    return true;
  }
}
